import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
    Flex,
    HorizontalDivider,
    IconAssignment,
    IconPrivacyTip,
    IconSupportAgent,
    SideNavLink,
    SidebarHeading,
    Stack,
} from '@myphx-engineering/phx-design-system';

import externalRoutes from '../../../external-routes';
import { routes } from '../../router/routes';

import { AddToContactsMenuItem } from './menu-items/AddToContactsMenuItem';
import { AddToHomeMenuItem } from './menu-items/AddToHomeMenuItem';

export const HelpAndSettingsSection = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Stack gap="sm">
            <HorizontalDivider variant="middle" />
            <Stack gap={0}>
                <Flex px="sm" pb="xxs">
                    <SidebarHeading>
                        {t('sidebar.helpAndSettings.heading')}
                    </SidebarHeading>
                </Flex>
                <AddToHomeMenuItem />
                <AddToContactsMenuItem />
                <SideNavLink
                    label={t('sidebar.helpAndSettings.support')}
                    Icon={IconSupportAgent}
                    onClick={() => {
                        navigate(routes.support);
                    }}
                />
                <SideNavLink
                    label={t('sidebar.helpAndSettings.privacyPolicy')}
                    Icon={IconPrivacyTip}
                    onClick={() =>
                        window.open(externalRoutes.privacyPolicy, '_blank')
                    }
                />
                <SideNavLink
                    label={t('sidebar.helpAndSettings.termsAndConditions')}
                    Icon={IconAssignment}
                    onClick={() =>
                        window.open(externalRoutes.termsConditions, '_blank')
                    }
                />
            </Stack>
        </Stack>
    );
};
